import React from "react";
import "./Example.css";

function Example() {
	return (
		<div className="example">
			<h2>Example</h2>
			<p>
				Your word puzzle has the available letters <kbd>ccceeintr</kbd>.
			</p>
			<ol>
				<li>
					You are looking for a 4 letter word with <kbd>c</kbd> as the
					2<sup>nd</sup> character.
					<ol>
						<li>
							In the Letters Available field, enter all your
							letters <kbd>ccceeintr</kbd>
						</li>
						<li>
							In the Pattern field, type <samp>_c__</samp>
						</li>
						<li>Click Find.</li>
					</ol>
				</li>
				<li>
					You're looking for all 7 letter words.
					<ol>
						<li>
							In the Letters Available field, enter all your
							letters <kbd>ccceeintr</kbd>
						</li>
						<li>Enter 7 underscores in the pattern field, OR</li>
						<li>
							Leave the pattern field empty and move size slider
							to 7.
						</li>
						<li>Click Find.</li>
					</ol>
				</li>
			</ol>
		</div>
	);
}

export default Example;
